export const HOTELS_LANDING_PAGE = '/hotels/';
export type HOTELS_LANDING_PAGE = typeof HOTELS_LANDING_PAGE;

export const HOTELS_SRP = '/hotels/search/';
export type HOTELS_SRP = typeof HOTELS_SRP;
